import { createSlice } from "@reduxjs/toolkit";
import { DTOResultTaxAssessemnet } from "../../Services/Serverless/Lookup/SBL/SBL.interface";
import { DobNowPropertyDetails } from "../../Services/Serverless/Lookup/DobBin/DobBin.interface";
/*
import { ITaxTableRow } from "../../Services/Serverless/Lookup/TaxHistory/TaxHistory.interface";
import {
  DTOResponseViolationsDob,
  DTOResponseViolationsDobEcb,
  DTOResponseViolationsHpd,
} from "../../Services/Serverless/Lookup/Violations/Violations.interface";
import { CoPDFInfo } from "../../Services/Serverless/Lookup/Co/Co.interface";
import { DobJob } from "../../Services/Serverless/Lookup/Permits/OpenData/dobJobs.interface";
import { DobnowElecPermit } from "../../Services/Serverless/Lookup/Permits/OpenData/dobnowElecPermits.interface";
import { DobnowJob } from "../../Services/Serverless/Lookup/Permits/OpenData/dobnowJobs.interface";
import { DobnowLaa } from "../../Services/Serverless/Lookup/Permits/OpenData/dobnowLaa.interface";
import { DobnowAppPermit } from "../../Services/Serverless/Lookup/Permits/OpenData/dobnowAppPermits.interface";
*/
export interface StoreProperty {
  assessment: DTOResultTaxAssessemnet | null;
  dobnow: DobNowPropertyDetails | null;
  /*
  taxSummary: ITaxTableRow[];
  permits: {
    dobJobs: DobJob[];
    dobnowElecPermits: DobnowElecPermit[];
    dobnowJobs: DobnowJob[];
    dobnowLaas: DobnowLaa[];
    dobnowAppPermits: DobnowAppPermit[];
  };
  violations: {
    violationsDob: DTOResponseViolationsDob[];
    violationsDobEcb: DTOResponseViolationsDobEcb[];
    violationsHpd: DTOResponseViolationsHpd[];
  };
  cos: CoPDFInfo[];
  */
}

export const initProperty: StoreProperty = {
  assessment: null,
  dobnow: null,
  /*
  taxSummary: [],
  permits: {
    dobJobs: [],
    dobnowElecPermits: [],
    dobnowJobs: [],
    dobnowLaas: [],
    dobnowAppPermits: [],
  },
  violations: {
    violationsDob: [],
    violationsDobEcb: [],
    violationsHpd: [],
  },
  cos: [],
  */
};

export const propertySlice = createSlice({
  name: "property",
  initialState: initProperty,
  reducers: {
    updatePropertyDobNow: (
      state,
      action: { payload: DobNowPropertyDetails },
    ) => {
      state.dobnow = action.payload;
    },
    updatePropertyAssessemnet: (
      state,
      action: { payload: DTOResultTaxAssessemnet },
    ) => {
      state.assessment = action.payload;
    },
    /*
    resetProperty: (state) => {
      state.assessment = initProperty.assessment;
      state.taxSummary = initProperty.taxSummary;
      state.dobnow = initProperty.dobnow;
      state.permits = initProperty.permits;
      state.violations = initProperty.violations;
      state.cos = initProperty.cos;
    },
    updatePropertyTaxSummary: (state, action: { payload: ITaxTableRow[] }) => {
      state.taxSummary = action.payload;
    },
    updatePropertyViolations: (
      state,
      action: {
        payload: {
          violationsDob: DTOResponseViolationsDob[];
          violationsDobEcb: DTOResponseViolationsDobEcb[];
          violationsHpd: DTOResponseViolationsHpd[];
        };
      },
    ) => {
      state.violations = action.payload;
    },
    updatePropertyPermits: (
      state,
      action: {
        payload: {
          dobJobs: DobJob[];
          dobnowElecPermits: DobnowElecPermit[];
          dobnowJobs: DobnowJob[];
          dobnowLaas: DobnowLaa[];
          dobnowAppPermits: DobnowAppPermit[];
        };
      },
    ) => {
      state.permits = action.payload;
    },
    updatePropertyCos: (state, action: { payload: CoPDFInfo[] }) => {
      state.cos = action.payload;
    },
    */
  },
});

// Action creators are generated for each case reducer function
export const {
  updatePropertyDobNow,
  updatePropertyAssessemnet,
  /*
  resetProperty,
  updatePropertyTaxSummary,
  updatePropertyViolations,
  updatePropertyPermits,
  updatePropertyCos,
  */
} = propertySlice.actions;

export default propertySlice.reducer;
